import { keycloakConfig } from '../contexts/auth-context';

const getDomainBaseUrl = (): string => {
  if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin;
  return keycloakConfig.baseUrl;
};

export const getKeycloakChangePasswordUrl = (): string => {
  const { url, realm, clientId } = keycloakConfig;
  const keycloakUrl = new URL(`${url}/realms/${realm}/protocol/openid-connect/auth`);
  keycloakUrl.searchParams.append('client_id', clientId);
  keycloakUrl.searchParams.append('redirect_uri', `${getDomainBaseUrl()}/home`);
  keycloakUrl.searchParams.append('response_type', 'code');
  keycloakUrl.searchParams.append('scope', 'openid');
  keycloakUrl.searchParams.append('kc_action', 'UPDATE_PASSWORD');
  return keycloakUrl.toString();
};

export const openKeycloakChangePassword = (): void => {
  window.open(getKeycloakChangePasswordUrl(), '_blank');
};
